import React from 'react';


export const Head = () => (
  <>
    <title>Ask Gemic</title>
    <meta
      name="Ask Gemic"
      content="2024 Trend Reports Edition"
    />
  </>
)